import { loginAPI } from './apis';
//addEventListener support for IE8
function bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler);
    }
}

const loginForm = document.getElementById('loginForm');
bindEvent(loginForm, 'submit', event => {
    event.preventDefault();
    const inputs = event.target.getElementsByTagName('input');
    const userObj = {
        personnel: inputs.userName.value,
        password: inputs.password.value
    };
    const responseObj = {
        type: 'token',
        data: {
            personnel: userObj.personnel
        }
    };

    loginAPI(userObj)
        .then(res => {
            responseObj.data.token = res.data.accessToken;
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            renderIframe(responseObj);
        });
});

function renderIframe(userData) {
    const iframeSource =
        'https://slot-management.netlify.app?clientId=embedded-login-poc&autologin=1';
    // Create the iframe
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', iframeSource);
    iframe.setAttribute('id', 'the_iframe');
    iframe.style.width = window.innerWidth - 40 + 'px';
    iframe.style.height = 480 + 'px';
    iframe.onload = function () {
        sendMessage(userData);
    };
    document.body.appendChild(iframe);
    // Send a message to the child iframe
    const iframeEl = document.getElementById('the_iframe');
    // Send a message to the child iframe
    const sendMessage = function (msg) {
        // Make sure you are sending a string, and to stringify JSON
        iframeEl.contentWindow.postMessage(msg, '*');
    };
}
